import { HttpEvent, HttpInterceptorFn, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, map, switchMap, throwError } from 'rxjs';
import { SessionService, TokenService } from '../services';
import { Router } from '@angular/router';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService: TokenService = inject(TokenService);
  const sessionService: SessionService = inject(SessionService);
  const jwt = tokenService.getToken();
  let request = req.clone();
  let params: HttpParams = req.params;
  if( jwt) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${jwt}`
      },
      params: params
    })
  }
  return next(request).pipe(
    map((event: HttpEvent<any>) => event ),
    catchError((error : any) => {
      if (error.status === 401) {
          return from(sessionService.refreshToken()).pipe(
            switchMap((newToken: string | null) => {
              if (newToken) {
                const clonedRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`,
                  },
                });
                return next(clonedRequest).pipe(
                  map((event: HttpEvent<any>) => event),
                  catchError((err: any) => {
                    return rejectFn();
                  })
                );
              }
              return rejectFn();
            })
          )
        }
        return throwError(() => error);
    })
  );
};

const rejectFn = () => {
  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);
  sessionService.logout();
  router.navigate(['login']);
  return throwError(() => new Error('No se pudo refrescar el token'));
}

